import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Certificate } from '@app/_models/certificate';
import { CertificateResponse } from '@app/_models/certificateResponse';
import { RsaProvided } from '@app/_models/rsaProvided';
import { environment } from '@environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CertificateService {
  private certificateSubject: BehaviorSubject<Certificate>;
  currentCertificate: Observable<Certificate>;

  constructor(private router: Router,
    private http: HttpClient) { 
      this.certificateSubject = new BehaviorSubject<Certificate>(new Certificate());
      this.currentCertificate = this.certificateSubject.asObservable();
    }
    public get currentCertificateValue(): Certificate {
      return this.certificateSubject.value;
  }
    setCertificate(certificate: Certificate){
      this.PrintCertificate = certificate;
      this.certificateSubject.next(certificate);
    } 
    public PrintCertificate: Certificate;

    issueBulkCertificate(certificates: Certificate[]){
      return this.http.post<CertificateResponse>(`${environment.apiUrl}/certificate/issueBulkCertificate`, certificates);
    }
    issueCertificate(certificate: Certificate){
    console.log("certificate: " + certificate);
    return this.http.post<CertificateResponse>(`${environment.apiUrl}/certificate/issueCertificate`, certificate);
  }
  editCertificate(certificate: Certificate){
    // console.log("certificate: " + certificate);
    return this.http.post<Certificate>(`${environment.apiUrl}/certificate/editCertificate`, certificate);
  }
  // Accept RsaProvided instead of Certificate
  rsaProvideCertificate(rsaProvided: RsaProvided) {
    return this.http.post<RsaProvided>(`${environment.apiUrl}/certificate/rsaProvideCertificate`, rsaProvided);
  }
  cancelCertificate(certificate: Certificate){
    console.log("certificate: " + certificate);
    return this.http.get(`${environment.apiUrl}/certificate/cancelCertificate/${certificate.id}`)

  }
  requestOnCertificate(certificate: Certificate){
    return this.http.post<Certificate>(`${environment.apiUrl}/certificate/requestOnCertificate`, certificate);
  }
  endorseRequestCertificate(certificate: Certificate){
    return this.http.post<Certificate>(`${environment.apiUrl}/certificate/endorseRequestCertificate`, certificate);
  }
  rejectEndorsementRequest(certificate: Certificate){
    return this.http.post<Certificate>(`${environment.apiUrl}/certificate/rejectEndorsementRequest`, certificate);
  }
  getRsaProvidedByCertificateNumber(certificateNumber: string) {
    return this.http.get<RsaProvided[]>(`${environment.apiUrl}/rsaservice/getRsaProvidedByCertificateNumber?certificateNumber=${certificateNumber}`);
  }

}
